import React, { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Button from "./Button";
import AddWallet from "./AddWallet";
import FoundOut from "./FundOut";
import FoundIn from "./FundIn";
import UpdateWallet from "./UpdateWallet";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { useAuth } from "../../../context/AuthProvider";
import { Backdrop, CircularProgress, Skeleton } from "@mui/material";
import QuickRecharge from "./QuickRecharge";
import GetServerLiveTime from "../../../constants/GetServerLiveTime";
import { usePermission } from "../../../context/PermissionContext";
import Messages from "../../../constants/Messages";
import ReactPaginate from "react-paginate";
import { CalendarIcon, ChevronRightIcon, EditIcon, WalletAltIcon } from "../../../constants/Icons";

function Recharge() {
  const [isBtnLoading, setBtnLoading] = useState(false);
   const [loading, setLoading] = useState({
    fundout:false,
    fundIn:false,
    updateWallet:false,
    addWallet:false
   });
  const [isPreLoading, setIsPreLoading] = useState(false); 
  const hasFetched = useRef(false);

  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const { isUser } = useAuth();
  const { permission, hasPermission } = usePermission();

  const [addNewWalletOpen, setNewWalletOpen] = useState(false);
  const [updateWalletOpen, setUpdateWalletOpen] = useState(false);
  const [fundInOpen, setFundInOpen] = useState(false);
  const [fundOutOpen, setFundOutOpen] = useState(false);
  const [listWallet, setListWallet] = useState([]);
  // const [addWallet, setAddWallet] = useState([]);
  // const [removeWallet, setRemoveWallet] = useState([]);
  const [selectedWalletId, setSelectedWalletId] = useState(null);
  const [viewRechargeWallet, setViewRechargeWallet] = useState([]);
  const [rechargeDate, setRechargeDate] = useState("");
  const [transactionList, setTransactionList] = useState([]);
  const [quickRecharge, setQuickRecarge] = useState(false);
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const perPage = 15;

  const getBgColor = (status) => {
    if (!status || typeof status !== "string") return "bg-label-secondary";
    switch (status.toLowerCase()) {
      case "cash":
        return "bg-label-success";
      case "upi":
        return "bg-label-moon";
      case "card":
        return "bg-label-flower";
      default:
        return "bg-label-secondary";
    }
  };
  const serverTime = GetServerLiveTime();
  const iso = serverTime.toISOString();
  const currentDate = DateConverter.convertToTimeZone(iso, isUser?.timezone);

  const handleNewWalletOpen = () => {
    if (
      hasPermission("RECHARGE", "RECHARGE:createWallet") ||
      permission === undefined
    ) {
      setNewWalletOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleNewWalletClose = () => {
    setNewWalletOpen(false);
  };

  const handleUpdateWalletOpen = () => {
    if (
      hasPermission("RECHARGE", "RECHARGE:addWalletAmount") ||
      permission === undefined
    ) {
      setUpdateWalletOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleUpdateWalletClose = () => {
    setUpdateWalletOpen(false);
  };

  const handleQuickRechargeOpen = () => {
    setQuickRecarge(true);
  };

  const handleQuickRechargeClose = () => {
    setQuickRecarge(false);
  };

  const handleFundInOpen = () => {
    if (
      hasPermission("RECHARGE", "RECHARGE:addFund") ||
      permission === undefined
    ) {
      setFundInOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleFundInClose = () => {
    setFundInOpen(false);
  };

  const handleFundOutOpen = () => {
    if (
      hasPermission("RECHARGE", "RECHARGE:removeFund") ||
      permission === undefined
    ) {
      setFundOutOpen(true);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleFundOutClose = () => {
    setFundOutOpen(false);
  };

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const handleRechargeDate = (newValue) => {
    if (!newValue) return;

    const selectedDate = newValue.toDate();
    const isoDateTime = selectedDate.toISOString();

    const tzDate = DateConverter.convertToTimeZone(
      isoDateTime,
      isUser?.timezone
    );

    setRechargeDate(tzDate);
    handleTransactionsList(tzDate);
  };

  const handleListRechargeWallet = async () => {
    setBtnLoading(true);
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(
        `module/recharge/list-recharge-wallet`
      );

      setListWallet(response?.data?.results || []);
      setBtnLoading(false);
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setBtnLoading(false);
    }
  };

  const handleNewWalletIn = async (walletname) => {
     setLoading((prev) => ({ ...prev, addWallet: true })); 
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.post(
        `module/recharge/create-recharge-wallet`,
        {
          walletname: walletname,
        }
      );

      // setListWallet(response?.data?.results ||[]);
      const fundIn = response.data.results;
      setListWallet((prev) => [
        {
          ...fundIn,
        },
        ...prev,
      ]);
      // setListWallet((prev) => {
      //   const exists = prev.some((item) => item._id === fundIn.wallet._id);

      //   if (exists) {
      //     return prev.map((item) =>
      //       item._id === fundIn.wallet._id
      //         ? { ...item, ...fundIn.wallet }
      //         : item
      //     );
      //   } else {
      //     return [...prev, fundIn.wallet];
      //   }
      // });
      // await handleListRechargeWallet();
      handleNewWalletClose();
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }finally{
       setLoading((prev) => ({ ...prev, addWallet: false })); 
    }
  };

  const handleUpdateWalletIn = async (walletamount) => {
      setLoading((prev) => ({ ...prev, updateWallet: true })); ;
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.patch(
        `module/recharge/add-recharge-wallet-amount`,
        {
          walletid: viewRechargeWallet?._id,
          walletamount: CurrencyConverter.toSubunit(walletamount || 0, "INR"),
        }
      );

      setViewRechargeWallet(response?.data?.results?.wallet || []);
      setTotalItems((prevCount) => prevCount + 1);
      const fundIn = response.data.results;
      setTransactionList((prev) => ({
        ...prev,
        ...fundIn.wallet,
        transactions: [{ ...fundIn.transaction }, ...prev.transactions],
      }));
      setListWallet((prev) => {
        const exists = prev.some((item) => item._id === fundIn.wallet._id);

        if (exists) {
          return prev.map((item) =>
            item._id === fundIn.wallet._id
              ? { ...item, ...fundIn.wallet }
              : item
          );
        } else {
          return [...prev, fundIn.wallet];
        }
      });
      // await handleListRechargeWallet();
      handleUpdateWalletClose();
      setLoading((prev) => ({ ...prev, updateWallet: false }));;
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
       setLoading((prev) => ({ ...prev, updateWallet: false })); ;
    }
  };

  // const handleViewRechargeWallet = async (walletId) => {
  //   try {
  //     if (!checkNetwork()) return;
  //     const response = await AxiosInstance.get(
  //       `module/recharge/view-recharge-wallet/${walletId}`
  //     );

  //     setViewRechargeWallet(response?.data?.results);
  //     setSelectedWalletId(response?.data?.results._id);
  //     const selectedDate = new Date();
  //     setRechargeDate(selectedDate);
  //     const formattedDate = formatDate(selectedDate);
  //     await handleTransactionsList(formattedDate, response?.data?.results?._id);
  //     return response.data.results;
  //   } catch (error) {
  //     handleError(error, showAlert);
  //     return false;
  //   }
  // };

  const handleViewRechargeWallet = async (walletId) => {
    if (
      hasPermission("RECHARGE", "RECHARGE:viewWallet") ||
      permission === undefined
    ) {
      setRechargeDate(currentDate);
      // const formattedDate = formatDate(selectedDate);
      setSelectedWalletId(walletId);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
    if (
      hasPermission("RECHARGE", "RECHARGE:listTransaction") ||
      permission === undefined
    ) {
      await handleTransactionsList(currentDate, walletId);
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  };

  const handleFundIn = async (amount, description) => {
    setLoading((prev) => ({ ...prev, fundIn: true }));
    try {
      if (!checkNetwork()) return;
      
      const response = await AxiosInstance.post(`module/recharge/add-fund`, {
        walletid: viewRechargeWallet?._id,
        amount: CurrencyConverter.toSubunit(amount || 0, "INR"),
        description: description,
      });

      // setAddWallet(response?.data?.results);
      setViewRechargeWallet(response?.data?.results?.wallet || []);
      const fundIn = response.data.results;
      setTransactionList((prev) => ({
        ...prev,
        ...fundIn.wallet,
        transactions: [{ ...fundIn.transaction }, ...prev.transactions],
      }));

      setListWallet((prev) => {
        const exists = prev.some((item) => item._id === fundIn.wallet._id);

        if (exists) {
          return prev.map((item) =>
            item._id === fundIn.wallet._id
              ? { ...item, ...fundIn.wallet }
              : item
          );
        } else {
          return [...prev, fundIn.wallet];
        }
      });
      setTotalItems((prevCount) => prevCount + 1);
      // await handleListRechargeWallet();
      handleFundInClose();
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }finally{
      setLoading((prev) => ({ ...prev, fundIn: false }));
    }
  };

  const handleFundOut = async (amount, description) => {
    setLoading((prev) => ({ ...prev, fundout: true }));
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.post(`module/recharge/remove-fund`, {
        walletid: viewRechargeWallet._id,
        amount: CurrencyConverter.toSubunit(amount || 0, "INR"),
        description: description,
      });

      setViewRechargeWallet(response?.data?.results?.wallet || []);
      // const selectedDate = new Date();
      // setRechargeDate(selectedDate);
      // const formattedDate = formatDate(selectedDate);
      // await handleTransactionsList(formattedDate, viewRechargeWallet?._id);
      const fundIn = response.data.results;
      setTransactionList((prev) => ({
        ...prev,
        ...fundIn.wallet,
        transactions: [{ ...fundIn.transaction }, ...prev.transactions],
      }));
      setListWallet((prev) => {
        const exists = prev.some((item) => item._id === fundIn.wallet._id);

        if (exists) {
          return prev.map((item) =>
            item._id === fundIn.wallet._id
              ? { ...item, ...fundIn.wallet }
              : item
          );
        } else {
          return [...prev, fundIn.wallet];
        }
      });
      setTotalItems((prevCount) => prevCount + 1);
      // await handleListRechargeWallet()
      handleFundOutClose();
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return false;
    }finally{
      setLoading((prev) => ({ ...prev, fundout: false }));
    }
  };

  const handleTransactionsList = async (rechargeDate, walletId, page = 0) => {
    setIsPreLoading(true);
    try {
      if (!checkNetwork()) return;
      var data = {
        walletid: walletId || viewRechargeWallet?._id,
        rechargeDate: rechargeDate,
        limit: perPage,
        pageno: page + 1,
      };
      const response = await AxiosInstance.post(
        `module/recharge/list-recharge-transactions`,
        data
      );

      setTransactionList(response?.data?.results);
      setViewRechargeWallet(response?.data?.results?.wallet || []);
      const results = response.data.results || [];

      if (
        !results ||
        !results.transactions ||
        results.transactions.length === 0
      ) {
        setTotalPages(0);
        setTotalItems(0);
        setCurrentPage(0);
      } else {
        setTotalPages(results.pagination?.pages || 0);
        setTotalItems(results.pagination?.total || 0);
      }
      //   await handleViewRechargeWallet(viewRechargeWallet?._id);
      handleFundOutClose();
      setIsPreLoading(false);
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return false;
    } finally {
      setIsPreLoading(false);
    }
  };

  useEffect(() => {
    if (listWallet?.length > 0 && hasFetched.current) {
      hasFetched.current = false;

      const firstWalletId = listWallet[0]?._id;
      setSelectedWalletId(firstWalletId);
      handleViewRechargeWallet(firstWalletId);
      setRechargeDate(currentDate);
      // const formattedDate = formatDate(selectedDate);
      if (
        hasPermission("RECHARGE", "RECHARGE:listTransaction") ||
        permission === undefined
      ) {
        // handleTransactionsList(currentDate, firstWalletId);
      } else {
        showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
      }
    }
  }, [listWallet]);

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    if (
      hasPermission("RECHARGE", "RECHARGE:viewWallet") ||
      permission === undefined
    ) {
      handleListRechargeWallet();
    } else {
      showAlert("warning", Messages.AUTH.PERMISSION_REQUIRED);
    }
  }, []);

  return (
    <>
      <div>
        <div className="page-wrapper">
          <div className="page-content">
            <div className="page-breadcrumb align-items-center mb-3">
              <div className="breadcrumb-title pe-3">Recharge</div>
            </div>
            <div className="row py-0">
              <div className="col-lg-3">
                <div className="card">
                  <div className="card-header px-3 py-3 d-flex flex-wrap justify-content-between align-items-center gap-3">
                    <div className="breadcrumb-title pe-3">Wallet</div>
                  </div>
                  {isBtnLoading ? (
                    [...Array(4)].map((_, index) => (
                      <ul
                        className="list-group list-group-flush radius-10"
                        key={index}
                      >
                        <li className="cursor-poInter wallet-list list-group-item p-2 d-flex align-items-center radius-10 my-1 border">
                          <Skeleton
                            variant="rectangular"
                            className="rounded"
                            width="100%"
                          />
                        </li>
                      </ul>
                    ))
                  ) : (
                    <div className="card-body mb-0">
                      <ul className="list-group list-group-flush radius-10">
                        {listWallet?.map((item) => (
                          <li
                            key={item?._id}
                            className={`cursor-poInter wallet-list list-group-item p-2 d-flex align-items-center radius-10 my-1 border ${
                              selectedWalletId === item?._id
                                ? "bg-label-info "
                                : ""
                            }`}
                            onClick={() => {
                              setCurrentPage(0);
                              handleViewRechargeWallet(item._id);
                            }}
                          >
                            <div className="d-flex align-items-center">
                              <div className="d-flex align-items-center mx-2 flex-grow-1">
                                <WalletAltIcon iClass={"me-2 fs-5"}/>
                                <h6
                                  className={`mb-0 fw-400 ${
                                    selectedWalletId === item?._id
                                      ? "text-primary"
                                      : ""
                                  }`}
                                >
                                  {item?.walletname} (
                                  <span>
                                    {CurrencyConverter.toCurrency(
                                      item?.walletbalance || 0,
                                      "INR"
                                    )}
                                  </span>
                                  )
                                </h6>
                              </div>
                            </div>
                            <div className="ms-auto">
                              <h6 className="mb-0">
                                <ChevronRightIcon iClass={"font-20"}/>
                              </h6>
                            </div>
                          </li>
                        ))}
                      </ul>

                      <div className="row g-3 pt-2">
                        <div className="col-lg-12">
                          <Button
                            text="New Wallet"
                            icon="ng ng-ng-add-icon"
                            bgColor="btn-primary"
                            textColor="text-white"
                            className="text-right w-100"
                            onClick={handleNewWalletOpen}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-lg-9">
                <div className="card">
                  {/* <div className="card-header px-3 py-3 ">
                    {Object.keys(viewRechargeWallet).length > 0 && (
                      <div className="row ">
                        <div className="col-lg-3 col-md-12 me-auto d-flex align-items-start">
                          <div className="py-1 ms-2">
                            <div className="chip border-0 text-primary bg-label-deep-info mb-0">
                              {viewRechargeWallet?.walletname}
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-12 pb-2 pb-lg-0">
                          <div class="d-flex flex-column text-center gap-3 cursor-poInter" onClick={handleUpdateWalletOpen}>
                            <div class="d-flex align-items-center justify-content-between bg-light p-2  radius-10">
                              <div class="flex-grow-1">
                                <h5 className="mb-0">
                                  ₹
                                  {CurrencyConverter.toCurrency(
                                    viewRechargeWallet?.walletbalance || 0,
                                    "INR"
                                  )}
                                </h5>
                                <p class="mb-0 text-dark">wallet Balance</p>
                              </div>
                              <div class="text-dark mx-2 font-30">
                                {" "}
                                <i className="ng ng-ng-edit-icon"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-2-5 col-lg-2-5-md-block col-6  d-flex align-items-center">
                          <Button
                            text="Fund Out"
                            icon="bx bx-minus"
                            bgColor="btn-danger"
                            textColor="text-white"
                            className="text-right w-100  fw-500 fs-12"
                            onClick={handleFundOutOpen}
                          />
                        </div>
                        <div className="col-lg-2-5  col-6 d-flex align-items-center">
                          <Button
                            text="Fund In"
                            icon="ng ng-ng-add-icon"
                            bgColor="btn-success"
                            textColor="text-white"
                            className="text-right  w-100 fw-500 fs-12"
                            onClick={handleFundInOpen}
                          />
                        </div>
                      </div>
                    )}
                    <div className="row mt-2">
                      <div className="col-lg-4 mx-auto">
                        <div class="d-flex flex-column text-center gap-3">
                          <div class="d-flex align-items-center justify-content-between bg-light p-2  radius-10">
                            <div class="flex-grow-1">
                              <h4 className="mb-0">₹790.00</h4>
                              <p class="mb-0 text-dark">wallet Balance</p>
                            </div>
                            <div class="text-dark mx-2 font-30 cursor-poInter">
                              {" "}
                              <i className="bx bx-edit-alt"></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  {listWallet?.length > 0 ? (
                    <>
                      <div className="card-header px-3 py-3 border-0">
                        <div className="row">
                          {loading.updateWallet ? (
                            <span
                              className="text-center"
                              sx={{
                                color: "#fff",
                                zIndex: (theme) => theme.zIndex.drawer + 1,
                                backgroundColor: "rgba(0, 0, 0, 0.1)",
                              }}
                              open={loading.updateWallet}
                            >
                              <CircularProgress color="inherit" />
                            </span>
                          ) : (
                            <>
                              <div className="col-lg-3 col-md-6 col-12 pb-2 pb-lg-0 d-flex align-items-center">
                                <div className="input-group w-200">
                                  <span className="input-group-text">
                                    <CalendarIcon/>
                                  </span>

                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DatePicker
                                      open={openDatePicker}
                                      onOpen={() => setOpenDatePicker(true)}
                                      onClose={() => setOpenDatePicker(false)}
                                      disableOpenPicker
                                      value={
                                        rechargeDate
                                          ? dayjs(rechargeDate)
                                          : dayjs(currentDate)
                                      }
                                      maxDate={dayjs(currentDate)}
                                      format="DD MMM YYYY"
                                      onChange={handleRechargeDate}
                                      slotProps={{
                                        textField: {
                                          className: "form-control",
                                          size: "small",
                                          onClick: () =>
                                            setOpenDatePicker(true),
                                          inputProps: {
                                            readOnly: true, // 🔒 no typing
                                          },                                          
                                        onKeyDown: (e) => e.preventDefault(),
                                        sx: {
                                          "& .MuiInputBase-input": {
                                            cursor: "pointer", 
                                          },
                                        },
                                        },
                                      }}
                                    />
                                  </LocalizationProvider>
                                </div>
                              </div>
                              <div className="col-lg-2-5 pb-2 pb-lg-0 col-6  d-flex align-items-center">
                                <Button
                                  text="Fund Out"
                                  icon="bx bx-minus"
                                  bgColor="bg-label-danger"
                                  textColor="text-danger"
                                  className="text-right w-100  fw-500 fs-12 "
                                  onClick={handleFundOutOpen}
                                />
                              </div>
                              <div className="col-lg-3 col-md-12 pb-2 pb-lg-0">
                                <div
                                  class="d-flex flex-column text-center gap-3 cursor-poInter"
                                  onClick={handleUpdateWalletOpen}
                                >
                                  <div class="d-flex align-items-center justify-content-between bg-light p-2  radius-10">
                                    <div
                                      className="d-flex align-items-center mx-2 flex-grow-1"
                                      style={{ gap: "6px" }}
                                    >
                                      <WalletAltIcon iClass={"fs-18"}/>
                                      <h5
                                        className="mb-0"
                                        style={{ fontSize: "16px" }}
                                      >
                                        ₹
                                        {CurrencyConverter.toCurrency(
                                          viewRechargeWallet?.walletbalance ||
                                            0,
                                          "INR"
                                        )}
                                      </h5>
                                    </div>

                                    <div class="text-dark mx-2 font-14 ">
                                      {" "}
                                      <EditIcon/>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-2-5  col-6 d-flex align-items-center">
                                <Button
                                  text="Fund In"
                                  icon="ng ng-ng-add-icon"
                                  bgColor="bg-label-success"
                                  textColor="text-success"
                                  className="text-right  w-100 fw-500 fs-12 "
                                  onClick={handleFundInOpen}
                                />
                              </div>
                            </>
                          )}
                          {/* <div className="col-lg-1  col-6 d-flex align-items-center">
                          <Button
                            text=""
                            icon="ng ng-ng-add-icon"
                            bgColor="bg-label-success"
                            textColor="text-success"
                            className="text-right  w-100 fw-500 fs-12 "
                            onClick={handleQuickRechargeOpen}
                          />
                        </div> */}
                          {/* <div className="col-lg-2 col-md-3 col-6">
                        <Button
                          text="Download PDF"
                          icon="bx bx-minus"
                          bgColor="btn-success"
                          textColor="text-white"
                          className="text-right w-100  fw-500 fs-12"
                          onClick={handleFundOutOpen}
                        />
                      </div>
                      <div className="col-lg-2 col-md-3 col-6">
                        <Button
                          text="Download Excel"
                          icon="bx bx-plus"
                          bgColor="btn-info"
                          textColor="text-white"
                          className="text-right  w-100 fw-500 fs-12"
                          onClick={handleFundInOpen}
                        />
                      </div> */}
                        </div>
                      </div>
                      <div className="card-body p-0 mb-3">
                        <div className="table-responsive">
                          <table className="table table-sm align-middle mb-0">
                            <thead className="table-light text-center">
                              <tr>
                                <th>S.No</th>
                                {/* <th>Date</th> */}
                                <th>Time</th>
                                <th>Operator</th>
                                <th>Number</th>
                                {/* <th>Wallet</th> */}
                                <th>Amount</th>
                              </tr>
                            </thead>
                            <tbody>
                              {isPreLoading ? (
                                [...Array(8)].map((_, index) => (
                                  <tr key={index}>
                                    {[...Array(6)].map((__, i) => (
                                      <td key={i} className="text-center">
                                        <Skeleton
                                          variant="text"
                                          width={i === 0 ? 50 : 120}
                                        />
                                      </td>
                                    ))}
                                  </tr>
                                ))
                              ) : transactionList?.transactions?.length > 0 ? (
                                transactionList?.transactions?.map(
                                  (item, index) => (
                                    <>
                                      {item?.tmode === "SALE" && (
                                        <tr>
                                          <td className="text-center">
                                            {" "}
                                            {totalItems -
                                              (currentPage * perPage + index)}
                                          </td>
                                          {/* <td className="text-center">
                                            {
                                              DateConverter.ISOToDisplayFormat(
                                                DateConverter.convertToTimeZone(
                                                  item?.createdAt,
                                                  "Asia/kolkata"
                                                )
                                              ).date
                                            }
                                          </td> */}

                                          <td className="text-center  text-heading fw-medium">
                                            {
                                              DateConverter.ISOToDisplayFormat(
                                                DateConverter.convertToTimeZone(
                                                  item?.createdAt,
                                                  "Asia/kolkata"
                                                )
                                              ).time
                                            }
                                          </td>

                                          <td className="text-center">
                                            <span className="text-heading fw-medium text-truncate">
                                              {item?.operator}
                                            </span>
                                          </td>

                                          <td className="text-center ">
                                            <span className="text-heading fw-medium text-truncate">
                                              {item?.number}
                                            </span>
                                          </td>
                                          <td className="text-center fw-medium fs-15">
                                            <span className="text-heading fw-medium text-truncate">
                                              {transactionList?.walletname}
                                            </span>
                                          </td>
                                          <td className="text-center">
                                            <span className="text-heading fw-medium text-truncate">
                                              ₹
                                              {CurrencyConverter.toCurrency(
                                                Number(item?.amount) || 0,
                                                "INR"
                                              )}
                                            </span>
                                          </td>
                                        </tr>
                                      )}
                                      {item?.tmode === "FUNDIN" && (
                                        <tr className="bg-label-success">
                                          <td className="text-center">
                                            {" "}
                                            {totalItems -
                                              (currentPage * perPage + index)}
                                          </td>
                                          {/* <td className="text-center">
                                            {
                                              DateConverter.ISOToDisplayFormat(
                                                DateConverter.convertToTimeZone(
                                                  item?.createdAt,
                                                  "Asia/kolkata"
                                                )
                                              ).date
                                            }
                                          </td> */}
                                          <td className="text-center">
                                            {
                                              DateConverter.ISOToDisplayFormat(
                                                DateConverter.convertToTimeZone(
                                                  item?.createdAt,
                                                  "Asia/kolkata"
                                                )
                                              ).time
                                            }
                                          </td>
                                          <td className="text-center">
                                            <div className="badge rounded-pill bg-light-success text-success  w-70">
                                              <span>{item?.tmode}</span>
                                            </div>
                                          </td>

                                          <td
                                            className="text-center"
                                            colSpan={1}
                                          >
                                            <span className="text-heading fw-medium text-truncate">
                                              {item?.description}
                                            </span>
                                          </td>
                                          <td className="text-center">
                                            <span className="text-heading fw-medium text-truncate">
                                              ₹
                                              {CurrencyConverter.toCurrency(
                                                Number(item?.amount) || 0,
                                                "INR"
                                              )}
                                            </span>
                                          </td>
                                        </tr>
                                      )}
                                      {item?.tmode === "FUNDOUT" && (
                                        <tr className=" bg-label-danger">
                                          <td className="text-center">
                                            {" "}
                                            {totalItems -
                                              (currentPage * perPage + index)}
                                          </td>
                                          {/* <td className="text-center">
                                            {
                                              DateConverter.ISOToDisplayFormat(
                                                DateConverter.convertToTimeZone(
                                                  item?.createdAt,
                                                  "Asia/kolkata"
                                                )
                                              ).date
                                            }
                                          </td> */}
                                          <td className="text-center">
                                            {
                                              DateConverter.ISOToDisplayFormat(
                                                DateConverter.convertToTimeZone(
                                                  item?.createdAt,
                                                  "Asia/kolkata"
                                                )
                                              ).time
                                            }
                                          </td>
                                          <td className="text-center">
                                            <div className="badge rounded-pill bg-light-danger text-danger w-70">
                                              {item?.tmode}
                                            </div>
                                          </td>

                                          <td
                                            className="text-center"
                                            colSpan={1}
                                          >
                                            <span className="text-heading fw-medium text-truncate">
                                              {item?.description}
                                            </span>
                                          </td>
                                          <td className="text-center">
                                            <span className="text-heading fw-medium text-truncate">
                                              ₹
                                              {CurrencyConverter.toCurrency(
                                                Number(item?.amount) || 0,
                                                "INR"
                                              )}
                                            </span>
                                          </td>
                                        </tr>
                                      )}
                                      {item?.tmode === "RESET" && (
                                        <tr className="bg-dark-light">
                                          <td className="text-center">
                                            {" "}
                                            {totalItems -
                                              (currentPage * perPage + index)}
                                          </td>
                                          {/* <td className="text-center">
                                            {
                                              DateConverter.ISOToDisplayFormat(
                                                DateConverter.convertToTimeZone(
                                                  item?.createdAt,
                                                  "Asia/kolkata"
                                                )
                                              ).date
                                            }
                                          </td> */}
                                          <td className="text-center">
                                            {
                                              DateConverter.ISOToDisplayFormat(
                                                DateConverter.convertToTimeZone(
                                                  item?.createdAt,
                                                  "Asia/kolkata"
                                                )
                                              ).time
                                            }
                                          </td>
                                          <td className="text-center">
                                            <span className="text-heading fw-medium text-truncate">
                                              Old Balance : ₹
                                              {CurrencyConverter.toCurrency(
                                                item?.oldbalance || 0,
                                                "INR"
                                              )}
                                            </span>
                                          </td>

                                          <td
                                            className="text-center "
                                            colSpan={1}
                                          >
                                            <span className="text-heading fw-medium text-truncate">
                                              wallet Balance : ₹
                                              {CurrencyConverter.toCurrency(
                                                item?.newbalance || 0,
                                                "INR"
                                              )}
                                            </span>
                                          </td>
                                          <td className="text-center">
                                            <span className="text-heading fw-medium text-truncate">
                                              Difference : ₹
                                              {CurrencyConverter.toCurrency(
                                                item?.oldbalance -
                                                  item?.newbalance || 0,
                                                "INR"
                                              )}
                                            </span>
                                          </td>
                                        </tr>
                                      )}
                                      {item?.tmode === "RECHARGE" && (
                                        <tr className="">
                                          <td className="text-center">
                                            {" "}
                                            {totalItems -
                                              (currentPage * perPage + index)}
                                          </td>
                                          {/* <td className="text-center">
                                            {
                                              DateConverter.ISOToDisplayFormat(
                                                DateConverter.convertToTimeZone(
                                                  item?.createdAt,
                                                  "Asia/kolkata"
                                                )
                                              ).date
                                            }
                                          </td> */}
                                          <td className="text-center">
                                            {
                                              DateConverter.ISOToDisplayFormat(
                                                DateConverter.convertToTimeZone(
                                                  item?.createdAt,
                                                  "Asia/kolkata"
                                                )
                                              ).time
                                            }
                                          </td>
                                          <td className="text-center">
                                            {item?.operator}
                                          </td>
                                          <td className="text-center ">
                                            {item?.number}
                                          </td>
                                          {/* <td className="text-center " >
                                        {item?.walletname}
                                      </td> */}
                                          <td className="text-center">
                                            ₹
                                            {CurrencyConverter.toCurrency(
                                              item?.amount || 0,
                                              "INR"
                                            )}
                                          </td>
                                        </tr>
                                      )}
                                       {item?.tmode === "RECHARGE_RETURNED" && (
                                        <tr className="bg-label-grey-2">
                                          <td className="text-center">
                                            {" "}
                                            {totalItems -
                                              (currentPage * perPage + index)}
                                          </td>
                                          {/* <td className="text-center">
                                            {
                                              DateConverter.ISOToDisplayFormat(
                                                DateConverter.convertToTimeZone(
                                                  item?.createdAt,
                                                  "Asia/kolkata"
                                                )
                                              ).date
                                            }
                                          </td> */}
                                          <td className="text-center">
                                            {
                                              DateConverter.ISOToDisplayFormat(
                                                DateConverter.convertToTimeZone(
                                                  item?.createdAt,
                                                  "Asia/kolkata"
                                                )
                                              ).time
                                            }
                                          </td>
                                          <td className="text-center">
                                            {item?.description}
                                          </td>
                                          <td className="text-center ">
                                            {item?.tmode}
                                          </td>
                                          {/* <td className="text-center " >
                                        {item?.walletname}
                                      </td> */}
                                          <td className="text-center">
                                            ₹
                                            {CurrencyConverter.toCurrency(
                                              item?.amount || 0,
                                              "INR"
                                            )}
                                          </td>
                                        </tr>
                                      )}
                                    </>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td colSpan="7" className="text-center p-2">
                                    <span className="text-muted">
                                      No Recharge found in the store. Add some
                                      Recharge to get started.
                                    </span>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>

                        {totalPages > 0 && (
                          <div className="d-flex justify-content-center mt-3">
                            <ReactPaginate
                              previousLabel={"← Previous"}
                              nextLabel={"Next →"}
                              breakLabel={"..."}
                              onPageChange={({ selected }) => {
                                setIsPreLoading(true);
                                setCurrentPage(selected);
                                handleTransactionsList(
                                  rechargeDate,
                                  selectedWalletId,
                                  selected
                                );
                                return;
                              }}
                              pageRangeDisplayed={5}
                              pageCount={totalPages}
                              containerClassName="pagination"
                              pageClassName="page-item"
                              pageLinkClassName="page-link"
                              previousClassName="page-item"
                              previousLinkClassName="page-link"
                              nextClassName="page-item"
                              nextLinkClassName="page-link"
                              breakClassName="page-item"
                              breakLinkClassName="page-link"
                              activeClassName="active"
                              forcePage={currentPage}
                            />
                          </div>
                        )}
                      </div>
                    </>
                  ) : (
                    <p className="p-2 mb-0 text-center">
                      {" "}
                      <span className="text-muted">
                        No Wallet found in the store. Add some Wallet to get
                        started.
                      </span>
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
            {addNewWalletOpen && (
        <AddWallet
          onClose={handleNewWalletClose}
          onNewWalletIn={handleNewWalletIn}
          isBtnLoading={loading.addWallet}
        />
      )}

      {updateWalletOpen && (
        <UpdateWallet
          onClose={handleUpdateWalletClose}
          onUpdateWalletIn={handleUpdateWalletIn}
          isBtnLoading={loading.updateWallet}
          walletBalance={viewRechargeWallet?.walletbalance}
        />
      )}

      {fundInOpen && (
        <FoundIn
          onClose={handleFundInClose}
          onFundIn={handleFundIn}
          isBtnLoading={loading.fundIn}
        />
      )}

      {fundOutOpen && (
        <FoundOut
          onClose={handleFundOutClose}
          onFundOut={handleFundOut}
          isBtnLoading={loading.fundout}
        />
      )}
      {quickRecharge && (
        <QuickRecharge
          onClose={handleQuickRechargeClose}
          onFundOut={handleFundOut}
          isBtnLoading={loading.fundout}
        />
      )}
        </div>
      </div>

    
    </>
  );
}

export default Recharge;
